import { errorHelpers } from '@approvalmax/utils';
import timeZones from 'countries-and-timezones';
import { type Country } from 'react-phone-number-input';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';
import enLabels from 'react-phone-number-input/locale/en.json';

export const getDefaultCountry = (): Country | undefined => {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        if (timeZone) {
            const country = timeZones.getCountryForTimezone(timeZone);

            if (country) {
                return country.id as Country;
            }
        }
    } catch (error) {
        errorHelpers.captureException(error);
    }

    return undefined;
};

export const getPhoneLabels = (): Record<Country | 'ZZ', string> => {
    try {
        return getCountries().reduce(
            (labels, country) => {
                labels[country] = enLabels[country] + ' +' + getCountryCallingCode(country);

                return labels;
            },
            {
                ZZ: enLabels['ZZ'],
            } as Record<Country | 'ZZ', string>
        );
    } catch (error) {
        errorHelpers.captureException(error);
    }

    return enLabels;
};
